import { Button } from '@components';
import { Typography, useTheme } from '@mui/material';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Warning from '../../EligibilityCheck/Warning';

interface IProps {
  onBack: () => void;
}

const ZipNotServedStep: React.FC<IProps> = ({ onBack }) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();

  return (
    <Warning>
      <Typography variant="overline" color="error.main" sx={{ marginBottom: theme.spacing(0.5) }}>
        <FormattedMessage id="preparingForNextSubmission.step.2.3.overline" />
      </Typography>
      <Typography variant="h2" sx={{ marginBottom: theme.spacing(2) }}>
        <FormattedMessage id="preparingForNextSubmission.step.2.3.title" />
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: theme.spacing(2) }}>
        <FormattedMessage id="preparingForNextSubmission.step.2.3.description.1" />
      </Typography>
      <Typography 
        variant="body1" 
        sx={{ marginBottom: theme.spacing(4) }} 
        dangerouslySetInnerHTML={{
          __html: formatMessage({ id: 'preparingForNextSubmission.step.2.3.description.2' }),
        }}
      />
      <Button variant="outlined" onClick={onBack}>
        <FormattedMessage id="common.back" />
      </Button>
    </Warning>
  );
};

export default ZipNotServedStep;
